"use strict";

// задаём значения по умолчанию для колорпикера
$.vanderlee.colorpicker.prototype._getCreateOptions = function(){
    return {
        "alpha" : true,
        "colorFormat": "RGBA",
        "containment" : "document",
        "inline" : false,
        "parts" : "draggable",
        "regional" : $("html").attr("lang"),
        "revert" : true,
        "showNoneButton" : false,
        "showOn" : "click",
        "showTransparentButton": false,
    };
};
